import { MessageCircle, Calendar, Sparkles, ArrowRight } from "lucide-react";
import { whatsappUrl } from "./constants";

const STEPS = [
  {
    n: "01",
    icon: MessageCircle,
    title: "Scrivimi su WhatsApp",
    desc: "Mi racconti il tuo obiettivo (dimagrimento, ricomposizione, performance) e fissiamo una chiamata conoscitiva gratuita di 15 minuti.",
    time: "2 minuti",
  },
  {
    n: "02",
    icon: Calendar,
    title: "Chiamata gratuita · 15 min",
    desc: "Capiamo se il metodo fa per te, rispondo a tutti i dubbi su tempi, costi e percorso. Nessun impegno, nessun preventivo automatico.",
    time: "15 minuti",
  },
  {
    n: "03",
    icon: Sparkles,
    title: "Primo appuntamento",
    desc: "Analisi antropometrica, anamnesi sportiva e clinica completa. Da lì costruisco il piano sartoriale: macro calcolati, strategie, calendario.",
    time: "60 minuti",
  },
];

export const HowToBook = () => {
  return (
    <section
      id="come-prenotare"
      data-testid="how-to-book-section"
      className="relative bg-white py-20 md:py-24 border-b border-[#E1E7E3]"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
              · Come prenotare
            </div>
            <h2 className="font-display text-[#0E1A14] text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Tre passi semplici.
              <br />
              <span className="text-[#1F6E45]">Zero pressione.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#4A5A52] text-base leading-relaxed">
            È la tua prima volta da un nutrizionista? Nessun problema. Il
            primo contatto è solo una chiacchierata: capiamo insieme se ha
            senso lavorare insieme, senza impegno.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 relative">
          {STEPS.map((s, i) => (
            <Step key={s.n} {...s} last={i === STEPS.length - 1} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="howto-whatsapp-cta"
            className="group inline-flex items-center gap-3 bg-[#1F6E45] text-white px-7 py-4 rounded-full font-semibold text-sm hover:bg-[#144A2E] transition-all green-glow"
          >
            <MessageCircle size={17} strokeWidth={2.2} />
            Inizia adesso · Step 1
            <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

const Step = ({ n, icon: Icon, title, desc, time, last }) => (
  <div className="relative bg-[#F7F9F7] border border-[#E1E7E3] rounded-2xl p-6 md:p-7 hover:border-[#1F6E45]/40 hover:-translate-y-1 transition-all duration-300 soft-shadow">
    {!last && (
      <div className="hidden md:block absolute top-12 -right-4 w-8 h-px bg-gradient-to-r from-[#C9D2CC] to-transparent" />
    )}
    <div className="flex items-start gap-4 mb-4">
      <div className="w-12 h-12 rounded-xl bg-[#1F6E45] text-white grid place-items-center flex-shrink-0">
        <Icon size={20} strokeWidth={1.8} />
      </div>
      <div className="flex-1">
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#1F6E45] font-bold">
          Step {n}
        </div>
        <div className="text-xs text-[#6F7E76] mt-0.5">{time}</div>
      </div>
    </div>
    <h3 className="font-heading text-[#0E1A14] text-lg md:text-xl font-bold tracking-tight mb-2">
      {title}
    </h3>
    <p className="text-[#4A5A52] text-sm leading-relaxed">{desc}</p>
  </div>
);
